import React from 'react';
import { useTranslation } from 'react-i18next';

const SelfReadingHeader = () => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-end">
          <div className="col-sm-6 col-lg-6">
            <div className="row no-gutters align-items-center">
              <div className="col-auto col-sm-auto col-lg-5 pr-2 pr-sm-5 pr-lg-0">
                <span className="d-xl-none">{tLabels("selfReadingHeader.date")}</span>
                <span className="d-sm-none d-xl-inline">{tLabels("selfReadingHeader.createSelfReading")}</span>
              </div>
              <div className="col-auto col-sm col-lg-7 pl-2 pl-lg-0">
              {tLabels("selfReadingHeader.selfReadingType")}
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="row no-gutters align-items-end">
              <div className="col-auto col-sm-6 pl-sm-3 pl-lg-4">
                <span className="d-lg-none">{tLabels("selfReadingHeader.meter")}</span>
                <span className="d-sm-none d-lg-inline">{tLabels("selfReadingHeader.meterState")}</span>
              </div>  
              <div className="col col-sm-6 pl-2 pl-sm-0">
                {tLabels("selfReadingHeader.selfReadingState")}
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default SelfReadingHeader;
